/* The line `export const base_url = "";` is exporting a constant variable
named `base_url` with the value `""`. This means that the `base_url`
variable can be accessed and used in other modules or files that import this module. */

export const Token = "9i8h7g6f-5e4d-3c2b-1a0j-dcba098765fe";